import { Globe, Award, Users } from "lucide-react";

export default function YoungEngineersCredibility() {
  return (
    <section
      className="rounded-[2rem] bg-gradient-to-br from-slate-900 to-slate-800 text-white p-8 sm:p-12"
      data-testid="ye-credibility"
    >
      <div className="grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-7">
          <p className="eyebrow text-slate-400">Curriculum partner</p>
          <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight font-extrabold mt-3 leading-[1.08]">
            Powered by the Young Engineers International Curriculum
          </h3>
          <div className="mt-5 space-y-4 text-slate-300 leading-relaxed text-sm sm:text-base">
            <p>
              Young Engineers was founded in 2008 and operates educational
              engineering programs in more than 50 countries worldwide.
            </p>
            <p>
              The curriculum has served tens of thousands of students globally
              and has received international recognition for its innovative
              approach to STEM education.
            </p>
            <p>
              Through hands-on engineering challenges and project-based
              learning, students develop critical thinking, creativity, and
              real-world problem-solving skills in an engaging and supportive
              environment.
            </p>
          </div>
        </div>

        <div className="lg:col-span-5 grid gap-3">
          <Stat
            icon={Globe}
            value="50+"
            label="countries running Young Engineers"
          />
          <Stat
            icon={Users}
            value="Tens of thousands"
            label="of students taught globally"
          />
          <Stat
            icon={Award}
            value="Since 2008"
            label="of curriculum development"
          />
        </div>
      </div>
    </section>
  );
}

function Stat({ icon: Icon, value, label }) {
  return (
    <div className="rounded-2xl bg-white/5 border border-white/10 p-5 flex items-start gap-4">
      <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-[#FF8C42] text-white shrink-0">
        <Icon className="h-5 w-5" />
      </span>
      <div>
        <p className="font-display font-extrabold text-white text-lg">{value}</p>
        <p className="text-xs text-slate-400 mt-0.5">{label}</p>
      </div>
    </div>
  );
}
